export default __webpack_public_path__ + "static/media/register11.547e8496.jpg";